import { render, staticRenderFns } from "./ProfileStaff.vue?vue&type=template&id=f0ca3b80&scoped=true&"
import script from "./ProfileStaff.vue?vue&type=script&lang=js&"
export * from "./ProfileStaff.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStaff.vue?vue&type=style&index=0&id=f0ca3b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ca3b80",
  null
  
)

export default component.exports